import { render, staticRenderFns } from "./ImportedArticlesOption.vue?vue&type=template&id=0d52c422&"
import script from "./ImportedArticlesOption.vue?vue&type=script&lang=js&"
export * from "./ImportedArticlesOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports